import Layout2 from '@/layout/Layout2'
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')

export default [{
  path: '/coupon',
  component: Layout2,
  children: [{
    path: '',
    name: 'coupon',
    component: () => import('@/merchanAdmin/coupon/couponList'),
    meta: {
      zhtitle: zh.m.aside.nav.COUPON_MANAGE,
      jatitle: ja.m.aside.nav.COUPON_MANAGE,
      pername: "coupons"
    }
  }, {
    path: 'create',
    name: 'couponcreate',
    component: () => import('@/merchanAdmin/coupon/couponDetail'),
    meta: {
      zhtitle: zh.m.router.common.CREATE,
      jatitle: ja.m.router.common.CREATE,
      pername: "coupons"
    }
  }, {
    path: 'detail',
    name: 'coupondetail',
    component: () => import('@/merchanAdmin/coupon/couponDetail'),
    meta: {
      zhtitle: zh.m.router.common.EDIT,
      jatitle: ja.m.router.common.EDIT,
      pername: "coupons"
    }
  }
  ]
}]
